import { EventEmitter, Directive, ElementRef, Renderer2, Input, Output, HostListener, NgModule } from '@angular/core';
import { getContentHeight, getLineHeight, truncate } from 'line-truncation';
import { BehaviorSubject, Subject } from 'rxjs';
import { skip, debounceTime } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
class LineTruncationDirective {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.lines = 1;
        this.options = { ellipsis: "\u2026" };
        this.watchChanges = false;
        this.hasTruncated = new EventEmitter();
        this.MAX_TRIES = 10;
        this.observerFlag = true;
        this._disabled$ = new BehaviorSubject(false);
        this.element = this.elementRef.nativeElement;
        this.windowResize$ = new Subject();
    }
    set disabled(val) {
        this._disabled$.next(val);
    }
    handleClick(event) {
        this.windowResize$.next(event);
    }
    /**
     * Hide the original text content until we've finished the truncation
     */
    ngOnInit() {
        this._disabled$.pipe(skip(1)).subscribe(disable => {
            // If there is elementClone, then recover
            if (!!this.elementClone) {
                this.putbackElement();
            }
            if (disable) {
                // shut down listener, observer
                this.disconnectMutationObserver();
                this.disconnectWindowLisener();
            }
            else {
                // re-register
                this.truncationInit();
                // re-execute truncation
                this.truncateWhenNecessary(this.element);
            }
        });
        // first emit handling
        if (!this._disabled$.getValue()) {
            this.truncationInit();
        }
    }
    ngAfterViewInit() {
        this.truncateWhenNecessary(this.element);
    }
    truncateWhenNecessary(element, tries = 1, maxTries = this.MAX_TRIES) {
        if (this._disabled$.getValue()) {
            return;
        }
        // backup original element before truncation
        this.elementClone = element.cloneNode(true);
        if (tries > maxTries) {
            return;
        }
        // Allows buffer period for DOM to be ready
        setTimeout(() => {
            // Recursively call the truncate itself if Client Height is not ready
            if (element.clientHeight > 0) {
                const contentHeight = getContentHeight(element);
                const lineHeight = getLineHeight(element);
                const targetHeight = this.lines * lineHeight;
                if (contentHeight > targetHeight) {
                    try {
                        truncate(element, this.lines, this.options.ellipsis, this.handler.bind(this));
                    }
                    catch (e) {
                        this.handler(true);
                    }
                }
                else {
                    // when there is no need, simply show the element, emit false and unsubscribe from MutationObserver if `watchChanges` prop was falsy
                    this.handler(false);
                }
            }
        }, 100);
    }
    handler(e) {
        this.isTruncated = e;
        this.hasTruncated.emit(this.isTruncated);
        if (!this.watchChanges) {
            this.observerFlag = false;
            this.disconnectMutationObserver();
        }
        this.renderer.removeStyle(this.element, "visibility");
    }
    truncationInit() {
        this.renderer.setStyle(this.element, "visibility", "hidden");
        this.initWindowResizeListener(this.element);
        this.initMutationObserver(this.element);
    }
    putbackElement() {
        // grab old child nodes
        const childNodes = Array.from(this.elementClone.childNodes);
        // clean element
        while (this.element.firstChild) {
            this.element.removeChild(this.element.firstChild);
        }
        // push child node to element shell
        childNodes.forEach(node => {
            this.element.appendChild(node);
        });
        this.elementClone = null;
    }
    initWindowResizeListener(element) {
        this.windowListener = this.windowResize$
            .pipe(debounceTime(500))
            .subscribe(() => {
            this.renderer.setStyle(element, "visibility", "hidden");
            this.putbackElement();
            this.truncateWhenNecessary(element);
        });
    }
    initMutationObserver(element) {
        this.mutationObserver = new MutationObserver(() => {
            if (this.observerFlag) {
                this.truncateWhenNecessary(element);
            }
        });
        this.mutationObserver.observe(element, {
            childList: true
        });
    }
    disconnectMutationObserver() {
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
    }
    disconnectWindowLisener() {
        if (this.windowListener) {
            this.windowListener.unsubscribe();
        }
    }
    ngOnDestroy() {
        this._disabled$.complete();
        this.disconnectMutationObserver();
        this.disconnectWindowLisener();
    }
}
LineTruncationDirective.ɵfac = function LineTruncationDirective_Factory(t) { return new (t || LineTruncationDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
LineTruncationDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: LineTruncationDirective, selectors: [["", "line-truncation", ""]], hostBindings: function LineTruncationDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function LineTruncationDirective_resize_HostBindingHandler($event) { return ctx.handleClick($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { lines: ["line-truncation", "lines"], options: "options", watchChanges: "watchChanges", disabled: "disabled" }, outputs: { hasTruncated: "hasTruncated" }, exportAs: ["lineTruncation"] });
LineTruncationDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
LineTruncationDirective.propDecorators = {
    lines: [{ type: Input, args: ["line-truncation",] }],
    options: [{ type: Input }],
    disabled: [{ type: Input }],
    watchChanges: [{ type: Input }],
    hasTruncated: [{ type: Output }],
    handleClick: [{ type: HostListener, args: ["window:resize", ["$event"],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LineTruncationDirective, [{
        type: Directive,
        args: [{
                selector: "[line-truncation]",
                exportAs: "lineTruncation"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { lines: [{
            type: Input,
            args: ["line-truncation"]
        }], options: [{
            type: Input
        }], watchChanges: [{
            type: Input
        }], hasTruncated: [{
            type: Output
        }], disabled: [{
            type: Input
        }], handleClick: [{
            type: HostListener,
            args: ["window:resize", ["$event"]]
        }] }); })();

class LineTruncationLibModule {
}
LineTruncationLibModule.ɵfac = function LineTruncationLibModule_Factory(t) { return new (t || LineTruncationLibModule)(); };
LineTruncationLibModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LineTruncationLibModule });
LineTruncationLibModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LineTruncationLibModule, [{
        type: NgModule,
        args: [{
                declarations: [LineTruncationDirective],
                exports: [LineTruncationDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LineTruncationLibModule, { declarations: [LineTruncationDirective], exports: [LineTruncationDirective] }); })();

/*
 * Public API Surface of line-truncation-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LineTruncationDirective, LineTruncationLibModule };

